<template>
  <div style="width: 100%;height:180px;">
    <el-amap
      class="amapCom-box"
      ref="amapCom"
      vid="amapCom-vue"
      :center="center"
      :plugin="plugin"
      :events="events"
      :zoom="zoom"
      :mapStyle="mapStyle"
      >

      <el-amap-marker
        :position="[pointInfo.reportAddressLong, pointInfo.reportAddressLat]"
        :offset="[-40, -36]"
      >
        <!-- <div class="point">
          {{ pointInfo.reportAddress }}
        </div> -->
        <div style="text-align: center;margin-top:8px;">
          <img
            style="width:32px;height:35px;"
            src="@/assets/daping/icon-address.png"
            alt=""
          />
        </div>
      </el-amap-marker>
    </el-amap>
  </div>
</template>

<script>
import Vue from "vue";
import VueAMap from "vue-amap";
Vue.use(VueAMap);

export default {
  name: "AMap",
  props: {
    pointInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },

  data() {
    return {
      showMap: false,
      amap: null,
      map: null,
      mapApiKey: "f6a6784aeb8609f7920f60ba3161ae54", //您申请的key值
      markersArray: [114.039587, 22.699961],
      zoom: 17,
      lnglatInfo: {
        lng: "",
        lat: "",
        addr: ""
      },
      searchOption: {
        city: "全国",
        citylimit: true
      },
      // center: [114.039587, 22.699961],
      center: [116.334529, 39.977991],
      defaultIcon: require("@/assets/image/add.png"),
      plugin: [
        // {
        //   pName: "Scale",
        //   events: {
        //     init(instance) {
        //       // console.log(instance)
        //     }
        //   }
        // },
        // {
        //   pName: "ToolBar",
        //   position: "RT",
        //   events: {
        //     init(instance) {
        //       // console.log(instance)
        //     }
        //   }
        // }
      ],
      events: {},
      // 绘制边界
      polygonConfig: {
        // 城市边界 配置
        strokeColor: "#5D87FB", // 城市边界颜色
        strokeWeight: 2,
        strokeStyle: "dashed", // 线样式
        fillColor: "#5D87FB", // 遮罩背景色
        fillOpacity: 0.1
      },
      polygonConfig2: {
        // 城市边界 配置
        strokeColor: "#47536e", // 城市边界颜色
        strokeWeight: 2,
        strokeStyle: "dashed", // 线样式
        fillColor: "#47536e", // 遮罩背景色
        fillOpacity: 0.1
      },
      polygons: {
        // 城市边界数据
        De: {}
      },
      district: null,
      polygonlist: [],
      mapStyle: "amap://styles/darkblue",
    };
  },
  created() {
  },
  mounted() {
    if (this.pointInfo.reportAddressLong) {
      this.center = [this.pointInfo.reportAddressLong, this.pointInfo.reportAddressLat]
    }
    this.$nextTick(() => {
      this.init();
    });
  },
  beforeDestroy() {
  },
  methods: {
    // 初始化地图
    init() {
      let _self = this;
      VueAMap.initAMapApiLoader({
        key: _self.mapApiKey,
        plugin: [
          "AMap.AutoComplete",
          "AMap.PlaceSearch",
          "AMap.Scale",
          "AMap.OverView",
          "AMap.ToolBar",
          "AMap.MapType",
          "AMap.PolyEditor",
          "AMap.CircleEditor",
          "AMap.Geocoder",
          "AMap.Boundary",
          "AMap.DistrictSearch",
          "AMap.Geolocation",
          "AMap.GeoJSON",
          "AMap.Heatmap"
        ],
        // 高德 sdk 版本
        v: "1.4.15"
      });
      setTimeout(async () => {
        _self.amap = _self.$refs.amapCom.$$getInstance();
      }, 1000);
    },
  },
  watch: {
    pointInfo: {
      deep: true,
      handler(val) {
        if (val.reportAddressLong) {
          this.center = [val.reportAddressLong, val.reportAddressLat]
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.amapCom-box {
  width: 100%;
  min-height: 180px;
}
/deep/.amap-logo {
  right: 0 !important;
  left: auto !important;
  display: none !important;
}

/deep/.amap-copyright {
  right: 70px !important;
  left: auto !important;
  opacity: 0 !important;
}

/deep/ .el-dialog__header {
  border-bottom: 0 !important;
}
.point {
  width: 300px;
  padding: 10px 24px;
  background: #fff;
  font-weight: 700;
  text-align: center;
  font-size: 14px;
  color: #494c4f;
  box-shadow: 0px 2px 4px 0px rgba(22, 54, 79, 0.08);
  border-radius: 33px;
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreenMini/components/centerItem/components/mapCom.vue